// extracted by mini-css-extract-plugin
module.exports = {"heading":"contactlink-module--heading--3d48l"};